import { lazy } from 'react'

import ManageBillingLoader from './loader'

export default {
  ManageBilling: {
    Component: lazy(() => import('./ManageBilling.Page')),
    Loader: ManageBillingLoader,
  },
}
